import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import PaymentImg from './../utils/resources/ModuleIcons/Payment.gif'
import StripeImg from './../utils/resources/ModuleIcons/stripe.png'
import VisaImg from './../utils/resources/ModuleIcons/visa.png'
import { IToastProps, NotificationToast } from "aw-notificationtoast";
import { Machine } from "../utils/models/Machine";
import { selectUser } from "../utils/redux/userSlice";
import { useSelector } from "react-redux";
import MachineSubscriptionGrid from "../components/MachinesComponents/MachinesSubscriptionsGrid/MachineSubscriptionsGrid.component";
import SubscriptionModal from "../components/SubscriptionModal/SubscriptionModal.component";
import CancelModal from "../components/SubscriptionModal/CancelModal/CancelModal.component";
import { getAllMachines } from "../utils/services/machine.service";
import { randInt } from "three/src/math/MathUtils";
import { SubscriptionType } from "../utils/const";


const PaymentModulePage = () => {
    const { t } = useTranslation();

    const [loding, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false })
    const [machines, setMachines] = useState<Machine[]>([])
    const [selectedMachine, setSelectedMachine] = useState<Machine | null>(null)

    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();

    useEffect(() => {
        context.setState(t('LicencesAndPayment'));
    })

    useEffect(() => {
        if (!loding) return
        getAllMachines(user.token).then((json: Machine[]) => {
            setMachines(json.map((machine: Machine) => {
                machine.licenseState = randInt(0, 4)
                const date = new Date()

                if (machine.licenseState === SubscriptionType.Active) {
                    date.setDate(date.getDate() + randInt(2, 10) * 30)
                    machine.expDate = date
                } else if (machine.licenseState === SubscriptionType.Trial) {
                    date.setDate(date.getDate() + 30)
                    machine.expDate = date
                } else if (machine.licenseState === SubscriptionType.Expired) {
                    date.setDate(date.getDate() - randInt(2, 10) * 30)
                    machine.expDate = date
                }

                return { ...machine }
            }).sort((a, b) => a.name.localeCompare(b.name)))
        }).catch(() => {
            showToastTimeOut(t('ErrorLoad'), true)
        }).finally(() => { setTimeout(() => { setLoading(false) }, 500) })
    }, [loding])

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast })
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000)
    }

    const onClickActivate = (m: Machine) => {
        setSelectedMachine(m)
        setShowModal(true)
    }

    const onClickCancel = (m: Machine) => {
        setSelectedMachine(m)
        setShowCancelModal(true)
    }

    const onHideModal = () => {
        setShowModal(false)
    }

    const onHideCancelModal = () => {
        setShowCancelModal(false)
    }

    const onChangeStateMachine = (activate: boolean) => {
        setMachines(prevMachines => prevMachines.map(machine => {
            if (machine.idmachine === selectedMachine?.idmachine) {
                const date = new Date();
                return {
                    ...machine,
                    licenseState: activate ? SubscriptionType.Trial : SubscriptionType.Canceled
                    , expDate: new Date(date.setDate(date.getDate() + 30))
                };
            }
            return machine;
        }));
    }

    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            {selectedMachine && <SubscriptionModal showModal={showModal} onHide={onHideModal} machine={selectedMachine} onChangeStateMachine={onChangeStateMachine} />}
            {selectedMachine && <CancelModal showModal={showCancelModal} onHide={onHideCancelModal} machine={selectedMachine} onChangeStateMachine={onChangeStateMachine} />}
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-9 p-1'>
                    <div className='p-2 rounded-1' style={{ backgroundColor: '#fff', height: 'auto', width: '100%', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        <MachineSubscriptionGrid loading={loding} machines={machines} onClickActivate={onClickActivate} onClickCancel={onClickCancel} iduser={user.iduser} />
                    </div>
                </div>
                <div className='col-12 col-md-3 p-1'>
                    <div className="p-4 h-100  rounded-1 d-flex flex-column justify-content-center align-items-center " style={{ backgroundColor: 'var(--background-secondary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)', overflow: 'hidden' }}>
                        <img src={StripeImg} style={{ maxHeight: '60%', maxWidth: '60%' }} />
                        <img src={VisaImg} className="mt-5 p-4 rounded-1" style={{ maxHeight: '80%', maxWidth: '80%' }} />
                    </div>

                </div>
            </div >
        </>
    )
}

export default PaymentModulePage;
